import cs from 'classnames';
import type { FC } from 'react';
import { useMemo } from 'react';
import useIsLandscape from '@/DesignSystem/Hook/useIsLandscape';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { DefaultLayoutFooterBottom } from './DefaultLayoutFooterBottom';
import { DefaultLayoutFooterMiddle } from './DefaultLayoutFooterMiddle';
import { DefaultLayoutFooterTop } from './DefaultLayoutFooterTop';
const DefaultLayoutFooter: FC = () => {
  const isLoggedIn = useLoggedIn();
  const isLandscape = useIsLandscape();
  return useMemo(() => {
    return <footer className={cs(isLandscape && 'pr-[74px]', 'bg-blueFive text-white')}>
        {!isLoggedIn && <DefaultLayoutFooterTop />}
        <DefaultLayoutFooterMiddle />
        <DefaultLayoutFooterBottom />
      </footer>;
  }, [isLoggedIn, isLandscape]);
};
export default DefaultLayoutFooter;